import { ListScopeProvider, ViewModeProvider } from '@kc-console/context';

import type { PropsWithChildren } from 'react';
import type { PanelViewMode } from '@kc-console/context';

/**
 * ListPanelProvider Props
 */
export interface ListPanelProviderProps extends PropsWithChildren {
  /**
   * Scope 키 (Panel Scope Registry 식별자)
   */
  scopeKey: string;

  /**
   * ViewMode (기본값: 'standalone')
   * - 'standalone': 패널 생성 가능
   * - 'embedded': 패널 생성 차단 (패널 내부 컨텐츠)
   */
  viewMode?: PanelViewMode;
}

/**
 * List 화면에서 선택 기반 패널을 사용하기 위한 Provider
 *
 * @description
 * 내부적으로 ViewModeProvider와 ListScopeProvider를 composition합니다.
 * DetailPanelProvider와 일관된 네이밍 및 패턴을 제공합니다.
 *
 * 향후 확장 포인트:
 * - 멀티 선택 모드 옵션
 * - 패널 위치 설정 (bottom/right)
 * - 패널 크기 제약 설정
 *
 * @example
 * ```tsx
 * <ListPanelProvider scopeKey="dns-zone-list">
 *   <ZoneListLayout>
 *     <ZoneListContent />
 *   </ZoneListLayout>
 * </ListPanelProvider>
 * ```
 */
export default function ListPanelProvider({
  scopeKey,
  viewMode = 'standalone',
  children,
}: ListPanelProviderProps) {
  return (
    <ViewModeProvider viewMode={viewMode}>
      <ListScopeProvider scopeKey={scopeKey}>{children}</ListScopeProvider>
    </ViewModeProvider>
  );
}
